import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Full-page chrome for admin sub-routes (replaces modal overlays).
 */
const AdminSubpage = ({ title, backTo, backLabel = '← Back', titleExtra, children }) => (
  <div className="admin-subpage">
    <div className="admin-subpage-toolbar">
      {backTo ? (
        <Link to={backTo} className="admin-back-link">
          {backLabel}
        </Link>
      ) : null}
      {title ? (
        <div className="admin-subpage-title-row">
          <h2 className="admin-subpage-title">{title}</h2>
          {titleExtra || null}
        </div>
      ) : null}
    </div>
    <div className="admin-subpage-body">{children}</div>
  </div>
);

export default AdminSubpage;
